"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordStatusService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordStatusService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordStatusService.instance) {
      return CordStatusService.instance;
    }
    super();
    this.applicationId = '';
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordStatusService.instance = this;
  }
  createStatus(data) {
    return this.post('status', data);
  }
  bulkInsert(data) {
    return this.post('status/bulkInsert', data);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getStatus(applicationId = this.applicationId) {
    return this.get('status', applicationId);
  }
  updateStatus(data, statusID) {
    return this.patch(`status/${statusID}`, data);
  }
  searchStatus(data) {
    return this.post(`status/search`, data);
  }
  deleteStatus(statusId) {
    return this.delete(`status/${statusId}`);
  }
}
exports.CordStatusService = CordStatusService;
CordStatusService.instance = null;
